import Vue from 'vue'
import Router from 'vue-router'
import about from '@/views/about' // 首页
import download from '@/views/download' // 首页

import Home from '@/views/Home' // 首页

import Login from '@/views/Login/Login' // 登录


Vue.use(Router)

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    routes: [
        // 登录
        { path: '/', name: 'Home', component: Home },
        // 页面
        { path: "/about", name: "about", component: about },
        { path: "/download", name: "download", component: download },
        // 新书发布
        // {
        //     path: "/newBookRelease", component: Layout, redirect: "/newBookRelease", children: [
        //         { path: "/newBookEntry", name: "newBookEntry", component: () => import("../views/newBookRelease/newBookEntry.vue"), },
        //         { path: "/BatchImport", name: "BatchImport", component: () => import("../views/newBookRelease/BatchImport.vue") },
        //         { path: "/upload/", name: "upload", component: () => import("../views/newBookRelease/upload.vue") },
        //     ]
        // },

    ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js